import { Icon } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Car } from '../../../../../../../types/SMT';
import LabeledParamFallback from '../../../../../../common/src/components/label-param-fallback/LabelParamFallback';
import { toEuro } from '../../../../utils/stringUtils';
import RiskObjectSelectRadio from '../RiskObjectSelectRadio';

interface Props {
  car: Car;
  isSelected: boolean;
  onSelect: () => void;
}

const CarSelectRadio: React.FC<Props> = ({ car, isSelected, onSelect }) => {
  const { t } = useTranslation();
  const { brand, model, number_plate, chassis_number, kw, value, name } = car;

  return (
    <RiskObjectSelectRadio
      isSelected={isSelected}
      onSelect={onSelect}
      icon={<Icon name="GeneralRiskObjectsCar" />}
      title={name || ''}
    >
      <LabeledParamFallback label={t('VEHICLE')}>
        {brand} {model}
      </LabeledParamFallback>
      {number_plate ? (
        <LabeledParamFallback label={t('NUMBER-PLATE')}>
          {number_plate}
        </LabeledParamFallback>
      ) : (
        <LabeledParamFallback label={t('CHASSIS-NUMBER')}>
          {chassis_number}
        </LabeledParamFallback>
      )}

      <LabeledParamFallback label={t('POWER')}>{kw}</LabeledParamFallback>
      <LabeledParamFallback label={t('CATALOGUE-VALUE')}>
        {value && toEuro(value)}
      </LabeledParamFallback>
    </RiskObjectSelectRadio>
  );
};

export default CarSelectRadio;
